export const PasswordMethodDataArr = [
  {
    id: "email",
    label: "Email Address",
    placeholder: "Enter Email Address",
    boxType: "input-box",
    boxSize: 3,
    type: "email",
    validatetype: "email",
    required: true,
  },
  {
    id: "password",
    label: "Email Password",
    placeholder: "Enter Password",
    boxType: "input-box",
    boxSize: 3,
    type: "password",
    validatetype: "acceptAll",
    required: true,
    showPassword: false,
    hasPasswordToggle: true,
  },
];

export const OtpMethodDataArr = [
  {
    id: "mobileNumber",
    label: "Mobile Number",
    placeholder: "Enter Mobile Number",
    boxType: "input-box",
    boxSize: 3,
    type: "number",
    validatetype: "number",
    required: true,
  },
  {
    id: "otp",
    label: "OTP",
    placeholder: "Enter OTP",
    boxType: "input-box",
    boxSize: 3,
    type: "number",
    validatetype: "number",
    required: true,
    readOnly: "true",
  },
];
